import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { SubscribeComponent } from 'src/app/shared/classes/subscribe-component';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { FilterConfig } from '../../models/filter-options.model';

@Component({
  selector: 'app-filter-options[config]',
  templateUrl: './filter-options.component.html',
  styleUrls: ['./filter-options.component.scss']
})
export class FilterOptionsComponent<T> extends SubscribeComponent implements OnChanges {
  @Input() config!: FilterConfig<T>;

  @Output() option = new EventEmitter<T | T[]>();

  public control: FormControl | null = null;

  constructor(
    public rwdService: RWDService,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    this.control = this.fb.control(this.config.multiple ? [] : null);
    this.subscription$.add(this.control!.valueChanges.subscribe((x) => this.option.emit(x)));
    this.reset();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config) {
      const conf = changes.config;
      this.control = this.fb.control(conf.currentValue.multiple ? [] : null);
      if (conf.previousValue?.default != conf.currentValue?.default) {
        this.control?.patchValue(conf.currentValue.default, { emitEvent: false });
      }
    }
  }

  public get default(): T | T[] {
    return this.config.default ?? (this.config.multiple ? [] : this.config.options[0].value);
  }

  public get value(): T | T[] {
    return this.control!.value;
  }

  public get isDefault(): boolean {
    return this.config.multiple ? ArrHlp.areEqual(this.value as T[], this.default as T[]) : this.value == this.default;
  }

  public reset(emitEvent = true): void {
    this.control!.patchValue(this.default, { emitEvent });
  }
}
